import type { InjectionKey } from 'vue'
import type { QuestionnaireFormV2 } from '../types'

export const REGISTER_INJECTION = Symbol('register') as InjectionKey<((form: QuestionnaireFormV2) => void)>

export const UNREGISTER_INJECTION = Symbol('unregister') as InjectionKey<() => void>
